// Activity slice — circular buffers of recent tag_events and location_events
// pushed in live by the realtime subscriptions in rtlsService. UI components
// (right-panel activity feed) can subscribe via selectors without forcing the
// subscription wiring to know about presentation details.
//
// Buffer cap is intentionally small (100 each). Realtime fire-hose can be
// surprising — bound it before it bites.

import {createSlice, type PayloadAction} from '@reduxjs/toolkit'

const BUFFER_CAP = 100

export type TagEventType = 'IN' | 'OUT'

export interface TagEventRecord {
  id: string
  tag_id: string
  personnel_id: string | null
  equipment_id: string | null
  type: TagEventType
  shift_id: string | null
  timestamp: string
}

export type LocationEventType = 'entry_in' | 'entry_out'

export interface LocationEventRecord {
  id: string
  location_id: string
  access_point_id: string | null
  personnel_id: string
  event_type: LocationEventType
  timestamp: string
}

interface ActivityState {
  tagEvents: TagEventRecord[]
  locationEvents: LocationEventRecord[]
}

const initialState: ActivityState = {
  tagEvents: [],
  locationEvents: [],
}

const activitySlice = createSlice({
  name: 'activity',
  initialState,
  reducers: {
    prependTagEvent(state, action: PayloadAction<TagEventRecord>) {
      state.tagEvents.unshift(action.payload)
      if (state.tagEvents.length > BUFFER_CAP) {
        state.tagEvents.length = BUFFER_CAP
      }
    },
    prependLocationEvent(state, action: PayloadAction<LocationEventRecord>) {
      state.locationEvents.unshift(action.payload)
      if (state.locationEvents.length > BUFFER_CAP) {
        state.locationEvents.length = BUFFER_CAP
      }
    },
    clearActivity(state) {
      state.tagEvents = []
      state.locationEvents = []
    },
  },
})

export const activityActions = activitySlice.actions
export default activitySlice.reducer
